/* src/app/forms/gridview/filterview/form-configuration/form-configuration.component.scss */
:host {
  display: flex;
  flex-direction: column;
  height: 100%;
  padding: 20px;
}
.example-container {
  width: 100%;
  max-width: 100%;
  display: flex;
  flex-direction: row;
  vertical-align: top;
  height: 100%;
  gap: 4px;
}
.button-disable {
  padding-right: 10px;
  padding-left: 10px;
}
.example-container .left {
  width: 50%;
  height: 100%;
  float: left;
  vertical-align: top;
  display: flex;
  flex-direction: column;
  overflow: auto;
  padding-top: 10px;
  gap: var(--tem-space-2);
}
.example-container .right {
  width: 50%;
  height: 100%;
  float: right;
  vertical-align: top;
  display: flex;
  flex-direction: column;
  padding-top: 10px;
  gap: var(--tem-space-2);
}
.example-list-left {
  border: solid 1px var(--tem-border);
  min-height: 40px;
  border-radius: 4px;
  overflow: auto;
  margin: 6px;
  height: 100%;
  max-height: 200px;
}
.example-list {
  border: solid 1px var(--tem-border);
  min-height: 40px;
  border-radius: 4px;
  overflow: auto;
  display: flex;
  flex-direction: column;
  margin: 6px;
  height: 100%;
}
.example-box {
  border-bottom: solid 1px var(--tem-border);
  display: flex;
  flex-direction: row;
  align-items: center;
  height: 40px;
  box-sizing: border-box;
  cursor: move;
  padding-top: 5px;
  padding-left: 10px;
  padding-bottom: 5px;
}
.example-box2 {
  border-bottom: solid 1px var(--tem-border);
  display: flex;
  flex-direction: row;
  align-items: center;
  box-sizing: border-box;
  cursor: move;
  margin-left: 6px;
  margin-right: 6px;
  padding-left: 10px;
  padding-top: 10px;
  padding-bottom: 10px;
}
.cdk-drag-preview {
  background-color: var(--tem-bg);
  box-sizing: border-box;
  border-radius: 4px;
  box-shadow:
    0 5px 5px -3px rgba(0, 0, 0, 0.2),
    0 8px 10px 1px rgba(0, 0, 0, 0.14),
    0 3px 14px 2px rgba(0, 0, 0, 0.12);
}
.cdk-drag-placeholder {
  opacity: 0;
}
.cdk-drag-animating {
  transition: transform 250ms cubic-bezier(0, 0, 0.2, 1);
}
.example-box:last-child {
  border: none;
}
.example-list.cdk-drop-list-dragging .example-box:not(.cdk-drag-placeholder) {
  transition: transform 250ms cubic-bezier(0, 0, 0.2, 1);
}
.accordion {
  width: 100%;
  display: flex;
  flex-direction: column;
  padding: 10px;
  overflow: auto;
  background: var(--tem-surface);
}
.flex-spacer {
  flex-grow: 1;
}
.rename-field {
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 2px;
  width: 100%;
}
.item {
  margin-left: 10px;
}
.title {
  display: flex;
  flex-direction: row;
  height: 50px;
  min-height: 50px;
  border: 1px solid var(--tem-border);
  background: var(--tem-surface-2);
  align-items: center;
  border-radius: var(--tem-radius);
  padding: 0 var(--tem-space-3);
  gap: var(--tem-space-2);
}
.title h4 {
  margin: 0;
  color: var(--tem-ink);
}
.info-left {
  display: flex;
  flex-direction: row;
  height: 100%;
  overflow: auto;
}
.title-expasion {
  display: flex;
  height: 100%;
  flex-direction: row;
  align-items: center;
  width: 100%;
}
.button-excluir {
  padding-right: 10px;
}
.drag-class {
  transform: rotate(90deg);
  margin-right: 10px;
}
/*# sourceMappingURL=form-configuration.component.css.map */
